import React from 'react';

const Footer: React.FC = () => {
  return (
    <footer className="bg-white dark:bg-gray-800 border-t border-gray-200 dark:border-gray-700 py-6 mt-12 no-print">
      <div className="container mx-auto px-4">
        <div className="text-center text-sm text-gray-600 dark:text-gray-400">
          <p>Built at Hackathon 2026 | Powered by RepoPilot</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;

// Made with Bob
